var map = {
	"./2.svg": 3669,
	"./23.svg": 6903,
	"./24.svg": 5533,
	"./25.svg": 9898,
	"./26.svg": 9710,
	"./4.svg": 487,
	"./7.svg": 8909,
	"./80.svg": 7440,
	"./82.svg": 6357,
	"./83.svg": 1222,
	"./84.svg": 5543,
	"./86.svg": 4380,
	"./87.svg": 7070,
	"./88.svg": 2461,
	"./89.svg": 546,
	"./90.svg": 2681,
	"./91.svg": 5039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 993;